module.exports = __webpack_public_path__ + "img/title_bg.f14745fe.png";